/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 出荷数量2
 * @export
 * @interface Col2
 */
export interface Col2 {
}

/**
 * Check if a given object implements the Col2 interface.
 */
export function instanceOfCol2(value: object): value is Col2 {
    return true;
}

export function Col2FromJSON(json: any): Col2 {
    return Col2FromJSONTyped(json, false);
}

export function Col2FromJSONTyped(json: any, ignoreDiscriminator: boolean): Col2 {
    return json;
}

export function Col2ToJSON(json: any): Col2 {
    return Col2ToJSONTyped(json, false);
}

export function Col2ToJSONTyped(value?: Col2 | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

